var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.containerStyle)},[_vm._t("default"),_vm._l((12 - (_vm.itemLength % 12 + 1)),function(index){return _c('DummyItemCardPrimary',{key:index + '_'})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }